import React from 'react';
import { Bucket } from '../../../containers/commerce';
import { BucketViewSimple } from '../../../components/commerce/Bucket';

export default () => (
  <Bucket display={BucketViewSimple} />
);
